import {Component} from '@angular/core';

@Component({
    selector: 'overlay-spinner',
    imports: [],
    templateUrl: './overlay-spinner.component.html',
    standalone: true,
    styleUrl: './overlay-spinner.component.scss'
})
export class OverlaySpinnerComponent {

    constructor(
    ) {
    }

}
